import React from 'react';
import PropTypes from 'prop-types';

import { AccordionSummary as MUIAccordionSummary } from '@material-ui/core';

export const AccordionSummary = props => <MUIAccordionSummary {...props} />;

AccordionSummary.propTypes = {
  IconButtonProps: PropTypes.object,
  classes: PropTypes.object,
  expandIcon: PropTypes.node
};

export default AccordionSummary;
